import { Box, ColorOptions, Form, ModBox, Spacer, Text } from '@jfs/ui-new'
import { ButtonNew } from '../../../../components/AdminButton'
import { useState } from 'react'
import { emGeneralConfigFormData } from './formData'

const FormBox = ({ children }: any) => {
  return <Box>{children}</Box>
}
const EmGeneralConfig = ({ name }: any) => {
  const [isEdit, setEditMode] = useState(false)
  const onEditPress = () => {
    setEditMode(true)
  }
  const onEditCancelPress = () => {
    setEditMode(false)
  }
  const onSavePress = () => {
    //TODO: Save changes to Store
    setEditMode(false)
  }
  return (
    <Box f={1} overflow={'auto'} ph={40} pv={40}>
      <Box flexDirection={'row'} justifyContent={'space-between'}>
        <Box>
          <Text title={'General Configuration'} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
          <Spacer size={18} direction={'vertical'} />
          <Box backgroundColor={'#FBF6EC' as ColorOptions} borderRadius={2} padding={4}>
            <Text
              title={`Below information is fetched from Parent(${name}). You may edit the information.`}
              color={'#A97425' as ColorOptions}
              fontSize={12}
              fontFamily={'jiotype-medium'}
            />
          </Box>
        </Box>
        <ModBox>
          <ModBox show={isEdit} direction={'row'}>
            <ButtonNew
              type={'secondarySmall'}
              borderWidth={1}
              title={'Cancel'}
              borderColor={'#0070B6'}
              borderRadius={4}
              onPress={onEditCancelPress}
            />
            <Spacer size={16} direction={'horizontal'} />
            <ButtonNew
              height={32}
              borderWidth={1}
              title={'Save Changes'}
              borderColor={'#0070B6'}
              borderRadius={4}
              onPress={onSavePress}
            />
          </ModBox>
          <ModBox show={!isEdit}>
            <ButtonNew
              type={'secondaryIconSmall'}
              borderWidth={1}
              title={'Edit'}
              borderColor={'#0070B6'}
              borderRadius={4}
              icon="EDIT"
              onPress={onEditPress}
            />
          </ModBox>
        </ModBox>
      </Box>
      <ModBox marginTop={32}>
        <Form
          formData={emGeneralConfigFormData(isEdit)}
          actionButtons={() => <></>}
          initialValues={{
            integrationType: '',
            sodexo: '',
            offers: '',
            commentsForOffers: '',
            emiFlag: '',
            tokenisationFlag: '',
            collectLink: '',
            subscription: '',
          }}
          container={FormBox}
        />
      </ModBox>
    </Box>
  )
}

export { EmGeneralConfig }
